exports.SimpleGlobal = require('./lib/simple-global').SimpleGlobal;



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/~/ng2-simple-global/index.js
// module id = ../../../../ng2-simple-global/index.js
// module chunks = 3